import StateData from "../components/DataToDisplay/StateData";

const StateDataPage = ()=>
{
    return (
      <StateData/>
    );
};

export default StateDataPage;